import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getInternalPortalAnnouncements } from "../api/api";
import LayoutBottom from "../Components/Layout/LayoutBottom";
import LayoutTop from "../Components/Layout/LayoutTop";

import AnnouncementSliderComponent from "../Components/Sliders/AnnouncementSliderComponent";


function ActivitiesPage() {

  const { t, i18n } = useTranslation();


const { isLoading, error, data, isFetching, refetch }: any = useQuery(
  "HomeSliderData",
  () => getInternalPortalAnnouncements({ limit: 20,table:'activities', language: i18n.language })
);


useEffect(() => {
  refetch();
}, [i18n.language]);

if (isLoading) return <div></div>;

if (error) return <div></div>;

var settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 2,
  dir: 'auto',
  rtl: true,
  arrows: false,
  responsive: [
      {
          breakpoint: 1024,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
          }
      },
      {
          breakpoint: 600,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
          }
      },
      {
          breakpoint: 480,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
      }
  ]
};

  return (
    <>
    <LayoutTop/>


    <div className="wrapper3 wrapper4">
            <div className="container-fluid">
                <h4 className="shape-round mb-lg-5 pb-5">الفعاليات</h4>
                <AnnouncementSliderComponent settings={settings} slides={data.data}/>
                
            </div>
        </div>
        <LayoutBottom/>

    </>
  );
}

export default ActivitiesPage;
